import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import "../../../../src/pages/data-visualization/chart-types.css";
import * as React from 'react';
export default {
  LeadParagraph,
  React
};